<template>
  <v-app>
    <v-app-bar app color="white" flat height="100" class="container">
      <div class="media-exit__header-logo-image">
        <img
          class="header-logo"
          src="../../assets/images/Media_Exit_0419.png"
          alt="media-exit"
        />
      </div>
    </v-app-bar>
    <v-container>
      <div class="d-flex align-center error-page-height">
        <div class="error-page">
          <div class="icon-holder">
            <img
              src="../../assets/images/error.svg"
              alt="file"
              width="97"
              height="86"
            />
          </div>
          <div class="page-not-found">page not found</div>
          <div class="need-assistance">Need assistance?</div>
          <div class="reference-desc">
            <p>
              Please contact
              <a href="#">List_Global_Fulfillment@aenetworks.com</a> in case of
              any issues related to this page. Thank you for your continued
              partnership with A+E Networks!
            </p>
          </div>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import Header from "../Header/HeaderPage.vue";
export default {
  data: () => ({
    isHeader: true,
  }),
  components: {
    Header,
  },
};
</script>

<style lang="scss" scoped>
@import "Error";
main.v-main.v-content {
  padding-top: 0px;
}
::v-deep {
  .v-app-bar.v-toolbar .v-toolbar__content {
    background: #fff;
  }
}
.error-page {
  margin-top: 120px;
}
.align-center {
  text-align: center;
}
</style>
